import { useSession } from '@common/contexts/session';
import {
  checkCustomPropertiesChecker,
  checkRightsChecker,
  districtCheckRightsChecker
} from '@util/auth';

export default () => {
  const { currentUser, rights: userRights, customProperties } = useSession();

  return {
    checkDistrictLevelRights: rightsToCheck =>
      districtCheckRightsChecker(userRights)(rightsToCheck),
    checkRights: (rightsToCheck, campuses) =>
      checkRightsChecker(userRights, campuses)(rightsToCheck) ||
      checkCustomPropertiesChecker(customProperties)(rightsToCheck),
    currentUserId: currentUser?.userId
  };
};
